import {connect} from 'react-redux';
import SuburbProfileMap from './SuburbProfileMap';
import {findSection, updateSectionValue} from 'ducks/reportSections';

const mapStateToProps = (state) => {
  const { propertyDetail, reportType, reportSections } = state;
  const section = findSection(reportSections, reportType.value, 'SUBURB_PROFILE');
  const { localityName, addressPostcode, addressState, latitude, longitude } = propertyDetail || {};

  let suburb = null;
  if (localityName) {
    const postcodeStr = addressPostcode ? ` ${addressPostcode}` : '';
    const stateStr = addressState ? `, ${addressState}` : '';
    suburb = `${localityName}${postcodeStr}${stateStr}`;
  }
  
  return {
    suburb,
    targetLatLng: { lat: latitude, lng: longitude },
    center: section?.sectionData?.mapCenter,
    zoom: section?.sectionData?.mapZoom,
    reportType: reportType.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onMapZoomChange: (value, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'SUBURB_PROFILE',
        dataKeyPath: 'sectionData.mapZoom',
      }, true));
    },
    onMapCenterChange: (value, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'SUBURB_PROFILE',
        dataKeyPath: 'sectionData.mapCenter',
      }, true));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onMapZoomChange: (value) => {
      dispatchProps.onMapZoomChange(value, stateProps.reportType);
    },
    onMapCenterChange: (value) => {
      dispatchProps.onMapCenterChange(value, stateProps.reportType);
    },
  };

};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SuburbProfileMap);